import React from 'react'
import styles from './IconButton.less'
import _ from 'common-tools/LodashHelper'
import { FAIcon } from './FAIcon'
import { ToolTip } from './ToolTip'
// import Tooltip from 'antd/lib/tooltip'
export class IconButton extends React.Component {
  static defaultProps = {
    helpTextPlacement: 'top',
    size: 'med',
    hide: false
  }

  render () {
    const { name, secondary, type, loading, className, onClick, id, isSubmit, helpText, size, helpTextPlacement, hide } = this.props

    if (hide === true) {
      return null
    }

    let clsNames = []

    clsNames.push(styles[`Button${secondary ? 'Secondary' : 'Primary'}${type || 'Default'}`])
    clsNames.push(styles[`${size}Button`])

    if (loading) {
      clsNames.push(styles.ButtonLoading)
    }

    let clsName = _.join(clsNames, ' ') + ' ' + className
    return (<span>
      {helpText ? <ToolTip placement={helpTextPlacement} toolTip={helpText}>
        <button type={isSubmit ? 'submit' : 'button'} id={id} className={clsName} onClick={loading ? null : onClick} >
          <FAIcon name={name} />
        </button>
      </ToolTip> : <button type={isSubmit ? 'submit' : 'button'} id={id} className={clsName} onClick={loading ? null : onClick} >
        <FAIcon name={name} />
      </button>}
    </span>
    )
  }
}

export default IconButton
